import { findIndexOptionsLanguages, returnTitleCapitalise } from './function';

export { findIndexOptionsLanguages, returnTitleCapitalise };
